import { Dispatch, SetStateAction } from "react";
import update from "immutability-helper";

export type StateHandle<S> = [S, Dispatch<SetStateAction<S>>];

/**
 * Provides a StateHandle<T> given a StateHandle for an Array of Ts and an index.
 * Useful for scoping down state to pass to a controlled component, for instance
 */
export function arrayIndexHandle<T>(arrayHandle: StateHandle<T[]>, index: number): StateHandle<T> | undefined {
  const value = arrayHandle[0][index];
  const updateFn = (action: SetStateAction<T>) => {
    if (typeof action === "function") {
      const refined = action as (t: T) => T;
      arrayHandle[1]((prev) => update(prev, { [index]: refined }));
    } else {
      arrayHandle[1]((prev) => update(prev, { [index]: { $set: action } }));
    }
  };
  return value !== undefined ? [value, updateFn] : undefined;
}

export function objectPropertyHandle<T, V extends keyof T>(objectHandle: StateHandle<T>, key: V): StateHandle<T[V]> {
  const value = objectHandle[0][key];
  const updateFn = (action: SetStateAction<T[V]>) => {
    if (typeof action === "function") {
      const refined = action as (v: T[V]) => T[V];
      objectHandle[1]((prev) => {
        const updated = refined(prev[key]);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return update(prev, { [key]: { $set: updated } });
      });
    } else {
      objectHandle[1]((prev) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return update(prev, { [key]: { $set: action } });
      });
    }
  };
  return [value, updateFn];
}
